import { v1Delete, v1Get, v1Patch, v1Post } from '@/services/v1Api';

/**
 * GET /api/v1/projects/{projectId}/reminders
 * Returns list of reminders for a project.
 */
export async function getReminders(projectId) {
  const { data } = await v1Get(`/api/v1/projects/${projectId}/reminders`);
  return Array.isArray(data) ? data : [];
}

/**
 * POST /api/v1/projects/{projectId}/reminders
 * Creates a new reminder.
 * Body: { message, due_at (ISO string), tagged_user_ids }
 */
export async function createReminder(projectId, reminder) {
  const body = {
    message: reminder.message ?? '',
    due_at: reminder.dueAt instanceof Date
      ? reminder.dueAt.toISOString()
      : reminder.due_at ?? reminder.dueAt ?? null,
    tagged_user_ids: reminder.taggedUserIds ?? reminder.tagged_user_ids ?? []
  };
  const { data } = await v1Post(`/api/v1/projects/${projectId}/reminders`, body);
  return data;
}

/**
 * PATCH /api/v1/projects/{projectId}/reminders/{reminderId}
 * Updates a reminder.
 */
export async function updateReminder(projectId, reminderId, updates) {
  const body = {};
  if (updates.message != null) body.message = updates.message;
  if (updates.dueAt != null) {
    body.due_at = updates.dueAt instanceof Date
      ? updates.dueAt.toISOString()
      : updates.due_at ?? updates.dueAt;
  }
  if (updates.taggedUserIds != null) body.tagged_user_ids = updates.taggedUserIds;
  if (updates.tagged_user_ids != null) body.tagged_user_ids = updates.tagged_user_ids;

  const { data } = await v1Patch(
    `/api/v1/projects/${projectId}/reminders/${reminderId}`,
    body
  );
  return data;
}

/**
 * DELETE /api/v1/projects/{projectId}/reminders/{reminderId}
 */
export async function deleteReminder(projectId, reminderId) {
  await v1Delete(`/api/v1/projects/${projectId}/reminders/${reminderId}`);
}

/**
 * POST /api/v1/projects/{projectId}/reminders/{reminderId}/snooze
 * Body: { minutes: number } (1–10080)
 */
export async function snoozeReminder(projectId, reminderId, minutes = 15) {
  const { data } = await v1Post(
    `/api/v1/projects/${projectId}/reminders/${reminderId}/snooze`,
    { minutes }
  );
  return data;
}
